// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ynbdental-backend.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-2o7f.onrender.com/";
export const weburl = "https://ynbdental-backend.onrender.com/";

export const shopurl = "https://adminynbdental.spacedeco.in/";
export const mainurl = "https://adminynbdental.spacedeco.in/";
export const fronturl = "https://ynbdental.spacedeco.in/";
export const socketURL = "https://ynbdental-backend.onrender.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;